import React from 'react'
import Modal from 'material-ui/Modal'
import Paper from 'material-ui/Paper'
import Button from 'material-ui/Button'
import Grid from 'material-ui/Grid'
import Icon from 'material-ui/Icon'
import Typography from 'material-ui/Typography'
import { Link } from 'react-router-dom'
import Input, { InputLabel } from 'material-ui/Input'
import { FormControl, FormHelperText } from 'material-ui/Form'
import { withStyles } from 'material-ui/styles'
import styles from '../styles'
import { validateFormData } from '../../../../common/formtool'
import classnames from 'classnames'
import {
  ModalHeader,
  ModalContents,
  ModalFooter
} from '../../modal'
import {APP_CONFIG} from "../../../../config";
import {toast} from "react-toastify";

class UploadAttachment extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      errors: {},
      error: null,
      jobtestattachment: null,
      upload: false,
      allowedExtensions: '',
      maxFileSize: 0,
    }
  }

  componentDidMount() {
    const { fileUploadSettings } = this.props;
    if (fileUploadSettings && fileUploadSettings.allowedAttachmentExtensions) {
      this.setState({
        allowedExtensions: fileUploadSettings.allowedAttachmentExtensions,
        maxFileSize: fileUploadSettings.maxAttachmentFileSize || APP_CONFIG.maxFileUploadSize
      })
    }
  }


  handleClose = () => {
    this.props.hideUplaodModal()
  }

  handleChange = (e) => {
    let errors = { ...this.state.errors }
    const restricted = ['#', '%', '/', '\\']
    if (e.target.type == 'file' && e.target.files.length) {
      const totalBytes = Object.keys(e.target.files).reduce((total, file) => (total + e.target.files[file].size), 0)
      // 1 MB = 1048576 bytes

      const { fileUploadSettings } = this.props;

      const fileSizeInMB = Math.round(totalBytes / 1048576);
      const maxAllowedFileSizeInMB =  fileUploadSettings.maxAttachmentFileSize || APP_CONFIG.maxFileUploadSize;
      const allowedExtensions = fileUploadSettings.allowedAttachmentExtensions;

      if (fileSizeInMB >= maxAllowedFileSizeInMB) {
        toast.error(` ${this.props.translate("jobs_upload_file_size_error", { value: maxAllowedFileSizeInMB })}`, {
          position: toast.POSITION.TOP_CENTER,
          hideProgressBar: true,
        })
        document.getElementById("jobtestattachment").value = "";
        this.setState({
          jobtestattachment: null,
        })
        return
      }

      if (allowedExtensions && allowedExtensions.length) {
        const fileName = e.target.files[0].name;
        const fileExtension = fileName.split('.').pop().toLowerCase();
        if (!allowedExtensions.includes(fileExtension)) {
          toast.error(` ${this.props.translate("jobs_upload_file_extension_error", { value: allowedExtensions.join(', ') })}`, {
            position: toast.POSITION.TOP_CENTER,
            hideProgressBar: true,
          })
          document.getElementById("jobtestattachment").value = "";
          this.setState({
            jobtestattachment: null,
          })
          return
        }
      }

      let fileExtention = e.target.files[0].name.split('.').pop();
      const restrictedChar = e.target.files[0].name.split("").some(ch => restricted.indexOf(ch) != -1)
      if (fileExtention !== 'exe' && !restrictedChar) {
        this.setState({
          [e.target.name]: e.target.files[0],
          errors: {
            ...errors,
            [e.target.name]: false
          },
          upload: true
        })
      } else {
        this.setState({
          errors: {
            ...errors,
            [e.target.name]: true
          },
          upload: false
        })
      }
    }
  }

  uploadFileAttachment = (e) => {
    const {
      uploadFile,
      hideUplaodModal
    } = this.props
    e.preventDefault()
    let file = this.state.jobtestattachment
    if (file) {
      var fd = new FormData();
      fd.append('file', file)
      uploadFile(fd)
      hideUplaodModal()
    }
  }

  render() {
    const {
      classes,
      languages,
      container,
      translate,
      attachments
    } = this.props

    const {
      errors,
      error,
      upload
    } = this.state

    return (
      <Modal
        open={true}
        onClose={this.handleClose}
      >
        <div className={classes.root}>
          <Paper className={classnames(classes.modal)}>
            <ModalHeader>
              <Grid container alignItems='center' direction='row' justify='flex-start'>
                <Grid item>
                  <Typography type="headline" color="inherit" className={classes.modalHeader}>
                    {translate('job_upload_attachments')}
                  </Typography>
                </Grid>
              </Grid>
              <Button
                className={classes.close}
                onClick={this.handleClose}
              >
              <Icon>clear</Icon>
              </Button>
            </ModalHeader>

            <ModalContents classes={classes.modal}>
              <form noValidate autoComplete="off" className={classes.form}>
                <FormControl
                  fullWidth
                  margin="normal"
                  error={errors.jobtestattachment ? true : false}
                >
                  <InputLabel
                    htmlFor="jobtestattachment"
                    shrink={true}
                    disableAnimation={true}
                  >
                    {translate("upload_attachment_label")}
                  </InputLabel>
                  <Input
                    className={classes.upload}
                    id="jobtestattachment"
                    type="file"
                    name="jobtestattachment"
                    onChange={this.handleChange}
                    inputProps={{
                      name: "jobtestattachment",
                      accept: this.state.allowedExtensions ? this.state.allowedExtensions.join(',') : null
                    }}
                    // inputProps={{
                  //   accept: ".pdf",
                  //   name: "jobtestattachment"
                  // }}
                  />
                  <FormHelperText id="jobtestattachment-helper-text">{translate("upload_attachment_help")}</FormHelperText>
                  <FormHelperText id="jobtestattachment-helper-text-2">{translate("security_file_upload_settings_allowed_attachment_extensions")}: {this.state.allowedExtensions ? this.state.allowedExtensions.join(',') : null}</FormHelperText>
                  <FormHelperText id="jobtestattachment-helper-text-3">{translate("security_file_upload_settings_max_attachment_file_size")}: {this.state.maxFileSize ? this.state.maxFileSize : null} MB</FormHelperText>
                </FormControl>
              </form>
            </ModalContents>

            <ModalFooter classes={classes}>

              <Button
              className={classes.submit}
                raised
                color="secondary"
                type="submit"
                onClick={this.uploadFileAttachment}
                disabled={!upload}
              >
                {translate("settings_upload")}
              </Button>
            </ModalFooter>

          </Paper>
        </div>
      </Modal>
    )
  }
}

export default withStyles(styles)(UploadAttachment)



// WEBPACK FOOTER //
// ./src/components/common/jobandtestattachments/add/index.js